import { useEffect } from "react";
import PageHeader from "../../Component/Common/PageHeader";
import PageContainer from "../../Component/Common/Page";
import Course from "./Course";
import CourseDetail from "./CourseDetail";
import { useDispatch, useSelector } from "react-redux";
import { selectCourse } from "../../store/course/course.action";

const Courses = () => {
  const dispatch = useDispatch();
  const { selectedCourse } = useSelector((state) => ({
    selectedCourse: state.course.selectedCourse,
  }));

  const handleSelectCourse = (course) => {
    dispatch(selectCourse(course));
  };

  const handleDeselectCourse = () => {
    dispatch(selectCourse(null));
  };

  useEffect(() => {
    return () => {
      handleDeselectCourse();
    };
  }, []);

  return (
    <PageContainer>
      {!selectedCourse ? (
        <>
          <PageHeader heading={"Welcome Admin"} subHeading={"Courses"} />

          <Course setSelectedCourse={handleSelectCourse} />
        </>
      ) : (
        <CourseDetail
          selectedCourse={selectedCourse}
          setSelectedCourse={handleDeselectCourse}
        />
      )}
    </PageContainer>
  );
};

export default Courses;
